import { Link } from 'react-router-dom';

/**
 * Standard header for public pages.
 *
 * <PageHeader
 *   title="Contact us"
 *   subtitle="…"
 *   crumbs={[{ label: 'Home', to: '/' }, { label: 'Contact' }]}
 *   actions={<Link className="pk-btn pk-btn--primary" to="/products">Browse</Link>}
 *   aside={<span>…</span>}   // right-aligned on wide screens
 *   center
 * />
 */
const PageHeader = ({ title, subtitle, crumbs, actions, aside, center = false, id }) => (
  <header className={`pk-head${center ? ' pk-head--center' : ''}`}>
    {crumbs?.length > 0 && (
      <nav aria-label="Breadcrumb">
        <ol className="pk-crumbs">
          {crumbs.map((crumb, i) => {
            const last = i === crumbs.length - 1;
            return (
              <li key={`${crumb.label}-${i}`}>
                {crumb.to && !last ? (
                  <Link to={crumb.to}>{crumb.label}</Link>
                ) : (
                  <span aria-current={last ? 'page' : undefined}>{crumb.label}</span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    )}
    <div className={aside ? 'pk-head__row' : undefined}>
      <div>
        <h1 className="pk-head__title" id={id}>
          {title}
        </h1>
        {subtitle && <p className="pk-head__sub">{subtitle}</p>}
      </div>
      {aside}
    </div>
    {actions && <div className="pk-head__actions">{actions}</div>}
  </header>
);

export default PageHeader;
